import type { Result, AppError } from '../../error/types';
import { isEnvironment } from './isEnvironment';
import { ENVIRONMENTS } from '../constants/ENVIRONMENTS';

/**
 * @group Functions
 * @summary <blockquote>Checks if the current environment is development.</blockquote>
 * 
 * @returns Result containing true if development, false otherwise
 * 
 * @example
 * ```typescript
 * import { isDevelopment } from '@shared/utils';
 * 
 * const result = isDevelopment();
 * result.match({
 *   ok: (isDev) => isDev && console.log('Development mode'),
 *   err: (error) => console.error(`Check failed: ${error.errorMessage}`)
 * });
 * ```
 */
export function isDevelopment(): Result<boolean, AppError> {
  return isEnvironment(ENVIRONMENTS.DEVELOPMENT);
}